import React, { createContext, useContext, ReactNode } from "react";
import { useSubSubscriberManagement } from "@root/hooks/useSubsubcriber";

interface SubSubscriberContextType {
  fetchSubsubscriber: (payload: any) => Promise<void>;
  addSubsubscriber: (payload: any) => Promise<any>;
  deleteSubsubscriber: (id: any) => Promise<any>;
  subsubscriberlLoading: boolean;
  addSubsubscriberlLoading: boolean;
  deleteSubsubscriberlLoading: boolean;
  subsubscriberData: any;
}

const SubSubscriberContext = createContext<SubSubscriberContextType | undefined>(
  undefined
);

interface SubSubscriberContextProviderProps {
  children: ReactNode;
}

export const SubSubscriberContextProvider: React.FC<
  SubSubscriberContextProviderProps
> = ({ children }) => {
  const data = useSubSubscriberManagement();

  return (
    <SubSubscriberContext.Provider value={data}>
      {children}
    </SubSubscriberContext.Provider>
  );
};


export const useSubSubscriberContext = (): SubSubscriberContextType => {
  const context = useContext(SubSubscriberContext);
  if (!context) {
    throw new Error(
      "useSubSubscriberContext must be used within a SubSubscriberContextProvider"
    );
  }
  return context;
};
